import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {

  constructor(public _dialogRef: MatDialogRef<HelpComponent>) {}

  modus: number = 1;
  ngOnInit() {
  }

}
